// extracted by mini-css-extract-plugin
module.exports = {"Summary":"ShipmentsSummaryComponent_Summary__1ivjE","Descriptions":"ShipmentsSummaryComponent_Descriptions__16pfN","Icons":"ShipmentsSummaryComponent_Icons__1LT0n"};